import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff, Link } from "react-feather";
import { createLogin } from "../../Service/AdminLoginService";
import { useToast } from "../toast/ToastProvider";

const AdminLogin = ({ onLogin }) => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await createLogin({ email, password });
             localStorage.setItem("token", response.data.token);

            toast(response.message || "Login successful 🎉");
            onLogin(email);
            navigate("/");
            setEmail("");
            setPassword("");
        } catch (error) {
            if (error.response && error.response.data) {
                const errData = error.response.data;
                const errMsg = errData.message || errData.error || "Login failed";
                toast(errMsg, "ERROR");
            } else {
                toast("Network or server error", "ERROR");
            }
            console.error("Login error:", error);
        }
    };

    return (
        <div
            className="d-flex align-items-center justify-content-center vh-100"
            style={{
                background: "linear-gradient(to right, #667eea, #764ba2)",
            }}
        >
            <div
                className="card shadow-lg p-4"
                style={{
                    width: "100%",
                    maxWidth: "400px",
                    borderRadius: "15px",
                }}
            >
                <div className="d-flex justify-content-center mb-3">
                    <img
                        src="/img/asa_logo.png"
                        alt="College Logo"
                        style={{ width: "80px", height: "auto" }}
                    />
                </div>
                <form onSubmit={handleSubmit}>
                    {/* Email */}
                    <div className="mb-3">
                        <label className="form-label fw-bold">UserId:</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter your UserId"
                            value={email}
                            onChange={(e) => {
                                const value = e.target.value;
                                setEmail(value);

                            }

                            }
                            required
                        />
                    </div>

                    {/* Password */}
                    <div className="mb-3">
                        <label className="form-label fw-bold" style={{ position: 'relative' }}>Password</label>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            className="form-control"
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <span onClick={() => setShowPassword(!showPassword)}
                            style={{
                                position: 'absolute',
                                right: '40px',
                                top: '70%',
                                cursor: 'pointer',
                            }}>{
                                showPassword ? <EyeOff /> : <Eye />}</span>
                    </div>

                    {/* Button */}
                    <div className="d-grid">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            style={{
                                backgroundColor: "#667eea",
                                borderColor: "#667eea",
                                borderRadius: "10px",
                            }}
                        >
                            Login
                        </button>
                    </div>
                </form>

                {/* 
        <p className="text-center mt-3 mb-0" style={{ fontSize: "14px" }}>
          Don’t have an account?{" "}
          <a href="/signup" className="fw-bold" style={{ color: "#667eea" }}>
            Sign up
          </a>
        </p> */}
            </div>
        </div>
    );
}
export default AdminLogin 